export const getRetailerDisplayName = (retailer: string): string => {
  const names: { [key: string]: string } = {
    CsMegastore: "CS MEGASTORE",
    NetOnNet: "NetOnNet",
    DustinHome: "Dustin Home",
  };
  return names[retailer] || retailer;
};

export const getRetailerColor = (retailer: string): string => {
  const colors: { [key: string]: string } = {
    Webhallen: "webhallenBlue",
    Proshop: "proshopRed",
    Komplett: "komplettYellow",
    Inet: "inetRed",
    Netonnet: "netonnetBlue",
    Amazon: "amazonOrange",
    CsMegastore: "csMegastoreBlue",
    Elgiganten: "elgigantenGreen",
    Alina: "alinaBlue",
    DustinHome: "dustinHomeGray",
    Power: "powerOrange",
  };
  return colors[retailer] || "gray";
};

export const getStockBadgeProps = (
  stockStatus: string
): { color: string; text: string; textColor?: string } => {
  switch (stockStatus) {
    case "in_stock":
      return { color: "green", text: "In Stock" };
    case "incoming":
      return { color: "yellow", text: "Incoming" };
    case "unknown":
      return { color: "dark", text: "Unknown", textColor: "dark.3" };
    case "out_of_stock":
    default:
      return { color: "dark", text: "Out of Stock", textColor: "dark.3" };
  }
};
